import { render, staticRenderFns } from "./CtaItem.vue?vue&type=template&id=25f64330&"
import script from "./CtaItem.ts?vue&type=script&lang=ts&"
export * from "./CtaItem.ts?vue&type=script&lang=ts&"
import style0 from "./CtaItem.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports